import React from 'react';
import { BsBoxArrowLeft, BsChevronExpand } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Flex, HStack,
  Icon,
  IconButton,
  Link as ChakraLink,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Text
} from '@chakra-ui/react';
import userflow from 'userflow.js';

import LogoBox from '../../../../components/Header/LogoBox';
import UserIcon from '../../../../components/UserIcon';
import { analyticsIds } from '../../../../constants/analyticsIds';
import { CypressIds } from '../../../../constants/cypressIds';
import { selectAgentPortalUser } from '../../../../redux/modules/agentPortal';
import boxStyles from '../../../../styles/boxStyles';
import { PageHeader } from '../../../../styles/layoutDimensions';
import { queryClient } from '../../../../utils/queryClientUtil';

const doTrackerResets = () => {
  window.heap.resetIdentity();
  userflow.reset();

  queryClient.clear();

  window.localStorage.removeItem('portal-api-token');
  window.localStorage.removeItem('portal-api-token-date');
};

const InsuranceRequestHeader = () => {
  const user = useSelector(selectAgentPortalUser);
  const { insuranceRequestId } = useParams();

  return (
    <Flex
      alignItems="center"
      bg="white"
      boxShadow={boxStyles.boxShadow}
      height={PageHeader.height}
      justifyContent="space-between"
      px={6}
      sx={{ position: 'sticky', top: 0 }}
      width="100%"
      zIndex={2}
    >
      <LogoBox to="/" />
      {user && user?.userEmail && (
        <HStack>
            {
              user?.userFirstName && (
                <UserIcon firstName={user.userFirstName} iconSize="40px" lastName={user.userLastName} />
              )
            }
          <Text mb={0} textStyle="bodyLg600">
            {user.userEmail}
          </Text>
          <Menu>
            <MenuButton
              as={IconButton}
              data-cy={CypressIds.headerUserCompaniesDropdown}
              dusk="header-user-companies-and-logout-action-dropdown"
              icon={<Icon as={BsChevronExpand} boxSize="18px" />}
              variant="unstyled"
            />
            <Portal>
              <MenuList p={2}>
                <ChakraLink
                  _hover={{ textDecor: 'none', color: 'inherit' }}
                  href={`/api/oauth/logout?redirect=${window.location.origin}/v2/insurance-requests/${insuranceRequestId}/verify`}
                >
                  <MenuItem
                    data-analytics-id={analyticsIds.header.headerLogoutButton}
                    data-cy={CypressIds.logoutButton}
                    dusk={analyticsIds.header.headerLogoutButton}
                    icon={<Icon as={BsBoxArrowLeft} boxSize="15px" />}
                    onClick={() => doTrackerResets()}
                  >
                    Logout
                  </MenuItem>
                </ChakraLink>
              </MenuList>
            </Portal>
          </Menu>
        </HStack>
      )}
    </Flex>
  );
};

export default InsuranceRequestHeader;
